import { t } from '@src/messages';

type CountryIsoCode = keyof typeof t.viberBusiness.countries;

export const getCountryIsoCodeLangFn = (isoCode: string): (() => string) => {
  const langFn = t.viberBusiness.countries[isoCode as CountryIsoCode];

  return langFn ?? t.viberBusiness.unknownCountry;
};
